import { ZERO } from "#packages/ecma402-abstract/constants.js";
import { invariant } from "#packages/ecma402-abstract/utils.js";
import Decimal from "@formatjs/bigdecimal";
/**
* CLDR operands for the implementation-defined PluralRuleSelect
* ECMA-402 §17.5.1 PluralRuleSelect, decimalString parameter and return definition.
* https://tc39.es/ecma402/#sec-pluralruleselect
* https://github.com/tc39/ecma402/blob/b1c961988b9a07894b1dc3dc2b5626ea48387d61/spec/pluralrules.html#L285-L290
*
* Implementation: Extended to support compact exponent (c/e operands)
*
* @param s Formatted number string
* @param exponent Compact decimal exponent (c/e operand), defaults to 0
*/
export function GetOperands(s, exponent = 0) {
	invariant(typeof s === "string", `GetOperands should have been called with a string`);
	// GetOperands consumes a formatted decimal string, not an ECMAScript Number.
	// ECMA-402 §17.5.1 PluralRuleSelect, decimalString parameter and return definition.
	// Preserve its mathematical value: https://tc39.es/ecma402/#sec-pluralruleselect
	// https://github.com/tc39/ecma402/blob/b1c961988b9a07894b1dc3dc2b5626ea48387d61/spec/pluralrules.html#L285-L290
	const n = new Decimal(s);
	invariant(n.isFinite(), "n should be finite");
	let dp = s.indexOf(".");
	let iv;
	let f;
	let v;
	let fv = "";
	if (dp === -1) {
		iv = s;
		f = ZERO;
		v = 0;
	} else {
		iv = s.slice(0, dp);
		fv = s.slice(dp, s.length);
		f = new Decimal(fv);
		v = fv.length;
	}
	const i = new Decimal(iv).abs();
	let w;
	let t;
	if (!f.isZero()) {
		const ft = fv.replace(/0+$/, "");
		w = ft.length;
		t = new Decimal(ft);
	} else {
		w = 0;
		t = ZERO;
	}
	return {
		Number: n,
		// Keep as string if too large for JavaScript number to preserve precision
		IntegerDigits: i.lessThanOrEqualTo(Number.MAX_SAFE_INTEGER) && i.greaterThanOrEqualTo(-Number.MAX_SAFE_INTEGER) ? i.toNumber() : i.toString(),
		NumberOfFractionDigits: v,
		NumberOfFractionDigitsWithoutTrailing: w,
		FractionDigits: f.toNumber(),
		FractionDigitsWithoutTrailing: t.toNumber(),
		CompactExponent: exponent
	};
}
